import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'SPANXPORT - Powering Intelligent Global Trade',
  description = 'SPANXPORT is your trusted partner for premium Indian agricultural exports. Spices, dry fruits, wellness products, and fresh produce delivered worldwide with quality assurance and full traceability.',
  keywords = 'export, import, spices, dry fruits, mangoes, grapes, pomegranates, Indian exports, B2B trade, agricultural exports, SPANXPORT',
  image = 'https://customer-assets.emergentagent.com/job_spanx-export/artifacts/xlq8jb39_SPANXPORT%20Logo%20Master.png',
  url,
  type = 'website',
  structuredData = null
}) => {
  const siteUrl = process.env.REACT_APP_BACKEND_URL || 'https://spanxport.com';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;

  // Default Organization structured data
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "SPANXPORT",
    "alternateName": "SPANXPORT Global Trade",
    "url": siteUrl,
    "logo": image,
    "description": "Powering Intelligent Global Trade - Premium Indian Agricultural Exports",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "sales",
      "availableLanguage": ["English", "Hindi"]
    },
    "sameAs": []
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="SPANXPORT" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="SPANXPORT" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Structured Data - Organization (always present) */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      
      {/* Custom Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

// Breadcrumb structured data helper
export const createBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

// Product structured data helper
export const createProductSchema = (product) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": product.name,
  "description": product.description,
  "image": product.image,
  "brand": {
    "@type": "Brand",
    "name": "SPANXPORT"
  },
  "offers": {
    "@type": "AggregateOffer",
    "priceCurrency": "INR",
    "lowPrice": product.lowPrice,
    "highPrice": product.highPrice,
    "offerCount": "1",
    "availability": "https://schema.org/InStock"
  },
  "category": product.category
});

// Local Business structured data
export const createLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SPANXPORT",
  "image": "https://customer-assets.emergentagent.com/job_spanx-export/artifacts/xlq8jb39_SPANXPORT%20Logo%20Master.png",
  "@id": "",
  "url": process.env.REACT_APP_BACKEND_URL,
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "India"
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    "opens": "09:00",
    "closes": "18:00"
  }
});

export default SEO;
